module.exports = __webpack_public_path__ + "static/media/skis.47ee93f9.svg";